import { render } from "./CadastreView.vue?vue&type=template&id=8a41dd98&scoped=true"
import script from "./CadastreView.vue?vue&type=script&lang=js"
export * from "./CadastreView.vue?vue&type=script&lang=js"

import "./CadastreView.vue?vue&type=style&index=0&id=8a41dd98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a41dd98"]])

export default __exports__